<template>
  <div class="myBalance">
    <!-- <div class="topBalance">
      <div class="wrap">
        <div class="balanceWrap">
          <p class="title">我的提货值</p>
          <p class="content">{{ allBanlce }}</p>
          <p class="dayprice">
            当日新增 <span>{{ Number(deliveyVal)>0 ? '+' + deliveyVal:deliveyVal }}</span>
          </p>
        </div>
        <div class="imgWrap">
          <img src="../../../assets/images/thzls.png" alt="">
        </div>
      </div>
    </div> -->
    <div class="myBalanceTotal">
      {{ allBanlce }} <span class="todaynew">当日新增{{ Number(deliveyVal) > 0 ? '+' + deliveyVal : deliveyVal }}</span>
    </div>
    <div class="chooseWrap">
      <div class="itemSearch">
        <el-date-picker
          v-model="search.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyyMMdd"
          :default-time="['00:00:00', '23:59:59']"
          :clearable="false"
          @blur="judgeTime"
        >
        </el-date-picker>
      </div>
      <div class="itemSearch">
        <el-radio-group v-model="search.radio" @change="changeRadio">
          <el-radio v-for="(rodioItem, index) of radioList" :key="index" :label="rodioItem.label">{{ rodioItem.name }}</el-radio>
        </el-radio-group>
      </div>
      <div class="itemSearch actionSearch">
        <el-button plain size="small" style="width: 75px; height: 32px; background: #1571db; border-color: #1571db; color: #ffffff" @click="searchData"
          >查询</el-button
        >
        <el-button size="small" style="width: 75px; height: 32px; background: #f4f4f4; border-color: #f4f4f4; color: #333333" @click="restData">重置</el-button>
      </div>
    </div>
    <div class="tableWrap">
      <el-table :data="tableData" border style="width: 100%">
        <template slot="empty">
          <div v-if="tableData.length == 0" class="no-datas1">
            <!-- <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" />
              <div style="text-align: center">暂无数据</div>
            </div> -->
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
        <el-table-column align="center" prop="flowId" label="流水号"> </el-table-column>
        <el-table-column align="center" prop="bizName" label="类型"> </el-table-column>
        <el-table-column align="center" prop="amount" label="发生额"> </el-table-column>
        <el-table-column align="center" prop="balance" label="资金余额"> </el-table-column>
        <el-table-column prop="occurTime" label="发生时间">
          <template slot-scope="scope">
            {{ scope.row.occurTime | dateFormate }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tableData.length > 0" class="pageStyle">
      <el-pagination
        popper-class="_popStyle"
        :current-page="pageData.currentPage"
        :page-sizes="pageData.pageSizes"
        :page-size="pageData.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="pageData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
/*global util protocol http */
export default {
  data() {
    return {
      allBanlce: null,
      balance: {},
      tableData: [],
      pageData: {
        total: 0,
        pageSizes: [5, 10, 20],
        pageSize: 10,
        currentPage: 1
      },
      protocolName: 'param_tq_tradeQuery_exportOrderFront',
      fileName: '委托明细.xlsx',
      isSearch: false,
      tabIndex: 0,
      search: {
        time: null,
        radio: 1
      },
      searchForm: {
        startTradeDay: null,
        endTradeDay: null,
        sort: [
          {
            direction: 'DESC', // "//DESC或ASC",
            property: 'flowId' // "//排序属性"
          }
        ]
      },
      treeTabIndex: 2,
      twoTabIndex: 0,
      radioList: [
        {
          label: 0,
          name: '当日'
        },
        {
          label: 1,
          name: '上日'
        },
        {
          label: 2,
          name: '上周'
        },
        {
          label: 3,
          name: '本周'
        },
        {
          label: 4,
          name: '上月'
        },
        {
          label: 5,
          name: '本月'
        },
        {
          label: 6,
          name: '最近三个月'
        }
      ],
      beginTimeT: [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))],
      beginZtime: [util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000), util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000)],
      currentDate: new Date(),
      millisecond: 1000 * 60 * 60 * 24, // 一天的毫秒数
      deliveyVal: 0
    }
  },
  created() {
    this.search.time = this.beginTimeT
    this.search.radio = 0
  },
  mounted() {
    this.findMyAsset()
    this.getThdAY()
    console.log('this.queryList', this.search.time)
    this.queryList()
  },
  methods: {
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.pageData.currentPage = 1
      this.queryList()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.queryList()
    },
    //   账户资金
    findMyAsset() {
      protocol.param_findMyRewardMarket.param.rewardId = 472
      http.getRes(protocol.param_findMyRewardMarket).then((response) => {
        const { code, message, value } = response.data
        if (code === '0') {
          this.allBanlce = value?.balance
        } else {
          this.$message(message)
        }
      })
    },
    //   当天提货值查询
    getThdAY() {
      protocol.param_currencyIncomeSumDay.param.symbolId = 472
      http.postFront(protocol.param_currencyIncomeSumDay).then((response) => {
        const { code, message, value } = response.data
        if (code === '0') {
          this.deliveyVal = value
        } else {
          this.$message(message)
        }
      })
    },
    queryList: function () {
      let protocolUrlData = protocol.param_queryFirmAccountFundsFlow
      if (this.search.time[0] != this.beginTimeT[0] || this.search.time[1] != this.beginTimeT[1]) {
        protocolUrlData = protocol.param_queryFirmAccountFundsFlowH
      }
      protocolUrlData.param.page = this.pageData.currentPage - 1
      protocolUrlData.param.size = this.pageData.pageSize
      protocolUrlData.param.marketId = 3
      protocolUrlData.param.startTradeDay = this.search.time[0]
      protocolUrlData.param.endTradeDay = this.search.time[1]
      protocolUrlData.param.symbolId = 472
      protocolUrlData.param.userId = sessionStorage.getItem('userId')
      protocolUrlData.param.typeCode = null
      protocolUrlData.param.sort = [
        {
          direction: 'DESC',
          property: 'flowId'
        }
      ]
      this.isGetRespond = false
      this.loading = true
      http.postFrontMk0(protocolUrlData).then((response) => {
        const { code, message, value } = response.data
        this.loading = false
        this.isGetRespond = true
        if (code === 0 || code === '0') {
          this.pageData.total = value.totalElements
          this.tableData = value.content
        } else {
          this.$message(message)
        }
      })
    },
    judgeTime(timeObj) {
      const beforWeek = this.formatTime(this.getLastWeek()) // 上周
      const currentWeek = this.formatTime(this.getThisWeek()) // 本周
      const beforMoth = this.formatTime(this.getLastMonth()) // 上月
      const currentMoth = this.formatTime(this.getThisMonth()) // 本月
      const newTime = timeObj.value
      if (this.beginTimeT[0] == newTime[0] && this.beginTimeT[1] == newTime[1]) {
        this.search.radio = 0
      } else if (this.beginZtime[0] == newTime[0] && this.beginZtime[1] == newTime[1]) {
        this.search.radio = 1
      } else if (beforWeek[0] == newTime[0] && beforWeek[1] == newTime[1]) {
        this.search.radio = 2
      } else if (currentWeek[0] == newTime[0] && currentWeek[1] == newTime[1]) {
        this.search.radio = 3
      } else if (beforMoth[0] == newTime[0] && beforMoth[1] == newTime[1]) {
        this.search.radio = 4
      } else if (currentMoth[0] == newTime[0] && currentMoth[1] == newTime[1]) {
        this.search.radio = 5
      } else {
        this.search.radio = 10 // 选择的日期不存在列表中
      }
    },
    // 判断两个时间是否超过一个月
    calcMoth(timer1, timer2) {
      const time1 = timer1.slice(0, 4) + '-' + timer1.slice(4, 6) + '-' + timer1.slice(6, 8)
      const time2 = timer2.slice(0, 4) + '-' + timer2.slice(4, 6) + '-' + timer2.slice(6, 8)
      const toime1 = new Date(time1).getTime()
      const toime2 = new Date(time2).getTime()
      const mountDay = 31 * 24 * 60 * 60 * 1000
      if (Number(toime1) - Number(toime2) > mountDay) {
        return true
      }
      return false
    },
    searchData() {
      // 搜索报表
      // if (this.calcMoth(this.search.time[1], this.search.time[0])) {
      //   return this.$message('查询时间不能大于1个月')
      // }
      // this.pageData = {
      //   total: 0,
      //   pageSizes: [5, 10, 20],
      //   pageSize: 10,
      //   currentPage: 1
      // }
      this.pageData.currentPage = 1
      this.queryList()
    },
    restData() {
      // 重置报表
      this.search.time = this.beginTimeT
      this.search.radio = 0
      this.isSearch = false
      this.isSearch = true
      this.pageData.currentPage = 1
      setTimeout(() => {
        this.isSearch = false
      }, 1000)
    },
    formatTime(list) {
      const listData = []
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          const timer = list[i].replace(/-/g, '')
          listData.push(timer)
        }
      }
      return listData
    },
    getThisWeek: function () {
      // 起止日期数组 本周
      // eslint-disable-next-line no-array-constructor
      var startStop = new Array()
      // 返回date是一周中的某一天
      var week = this.currentDate.getDay()
      // 减去的天数
      var minusDay = week != 0 ? week - 1 : 6
      // 本周 周一
      var monday = new Date(this.currentDate.getTime() - minusDay * this.millisecond)
      // 本周 周日
      // var sunday = new Date(monday.getTime() + (6 * this.millisecond))
      // 添加本周时间
      startStop.push(this.formatterDate(monday)) // 本周起始时间
      const today1 = util.dateDayFormate(Number(new Date())) // 今天
      // 添加本周最后一天时间
      startStop.push(today1) // 本周终止时间
      // startStop.push(this.formatterDate(sunday)) // 本周终止时间
      // 返回
      return startStop
    },
    /**
     * 获得上一周的起止日期
     */
    getLastWeek: function () {
      // 起止日期数组
      // eslint-disable-next-line no-array-constructor
      var startStop = new Array()
      // 返回date是一周中的某一天
      var week = this.currentDate.getDay()
      // 减去的天数
      var minusDay = week != 0 ? week - 1 : 6
      // 获得当前周的第一天
      var currentWeekDayOne = new Date(this.currentDate.getTime() - this.millisecond * minusDay)
      // 上周最后一天即本周开始的前一天
      var priorWeekLastDay = new Date(currentWeekDayOne.getTime() - this.millisecond)
      // 上周的第一天
      var priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - this.millisecond * 6)

      startStop.push(this.formatterDate(priorWeekFirstDay))
      startStop.push(this.formatterDate(priorWeekLastDay))
      // 返回
      return startStop
    },
    /**
     * 获得这个月的起止日期
     */
    getThisMonth: function () {
      // eslint-disable-next-line no-array-constructor
      var startStop = new Array()
      // 获得当前月份0-11
      var currentMonth = this.currentDate.getMonth()
      // 获得当前年份4位年
      var currentYear = this.currentDate.getFullYear()
      // 求出本月第一天
      var firstDay = new Date(currentYear, currentMonth, 1)
      // 当为12月的时候年份需要加1
      // 月份需要更新为0 也就是下一年的第一个月
      // 否则只是月份增加,以便求的下一月的第一天
      if (currentMonth == 11) {
        currentYear++
        currentMonth = 0
      } else {
        currentMonth++
      }
      // var nextMonthDayOne = new Date(currentYear, currentMonth, 1)
      // 求出上月的最后一天
      // var lastDay = new Date(nextMonthDayOne.getTime() - this.millisecond)
      const today1 = util.dateDayFormate(Number(new Date())) // 今天
      // 添加本周最后一天时间
      startStop.push(this.formatterDate(firstDay))
      // startStop.push(this.formatterDate(lastDay))
      startStop.push(today1) // 本周终止时间
      // 返回
      return startStop
    },
    /**
     * 获得上个月的起止日期
     */
    getLastMonth: function () {
      // eslint-disable-next-line no-array-constructor
      var startStop = new Array()
      // 获得当前月份0-11
      var currentMonth = this.currentDate.getMonth()
      // 获得当前年份4位年
      var currentYear = this.currentDate.getFullYear()
      var currentDay = new Date(currentYear, currentMonth, 1)
      // 上个月的第一天
      // 年份为0代表,是本年的第一月,所以不能减
      if (currentMonth == 0) {
        currentMonth = 11 // 月份为上年的最后月份
        currentYear-- // 年份减1
      } else {
        currentMonth--
      }
      var firstDay = new Date(currentYear, currentMonth, 1)
      // 求出上月的最后一天
      var lastDay = new Date(currentDay.getTime() - this.millisecond)

      startStop.push(this.formatterDate(firstDay))
      startStop.push(this.formatterDate(lastDay))
      // 返回
      return startStop
    },
    /**
     * 格式化日期（不含时间）
     */
    formatterDate: function (date) {
      var datetime =
        date.getFullYear() +
        '-' + // "年"
        (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
        '-' + // "月"
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
      return datetime
    },
    changeRadio(val) {
      switch (val) {
        case 0: // 当前
          this.search.time = [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))]
          break
        case 1: // 昨天
          this.search.time = [
            util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000),
            util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000)
          ]
          break
        case 2: // 上周
          this.search.time = this.formatTime(this.getLastWeek())
          break
        case 3: // 本周
          this.search.time = this.formatTime(this.getThisWeek())
          break
        case 4: // 上月
          this.search.time = this.formatTime(this.getLastMonth())
          break
        case 5: // 本月
          this.search.time = this.formatTime(this.getThisMonth())
          break
        case 6: // 最近三个月
          var today = new Date() // 当天
          today.setMonth(today.getMonth() - 3) // 三个月前，时间戳
          today.toLocaleDateString() // 格式化时间
          this.search.time = [util.formatnewDay(Number(new Date(today))), util.formatnewDay(Number(new Date()))]
          break
        default:
          this.search.time = [
            util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000),
            util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000)
          ]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.myBalance {
  .myBalanceTotal {
    margin-top: 23px;
    font-family: PingFang TC, PingFang TC;
    font-weight: 400;
    font-size: 24px;
    color: #333333;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(#000000, 0.1);

    display: flex;
    gap: 14px;
    align-items: baseline;
    .todaynew {
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .topBalance {
    margin: 40px 40px 30px;
    height: 180px;
    background: #424556;
    border-radius: 8px 8px 8px 8px;
    .wrap {
      display: flex;
      justify-content: space-between;
      width: 80%;
      height: 100%;
      margin: 0 auto;
      position: relative;
      .imgWrap {
        position: absolute;
        right: 0;
        top: -40px;
        width: 293px;
        height: 213px;
        img {
          width: 100%;
          height: 100%;
          vertical-align: middle;
        }
      }
      .balanceWrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .title {
          font-size: 20px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #ffffff;
          line-height: 26px;
        }
        .content {
          padding-top: 20px;
          font-size: 42px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: normal;
          color: #e4ca91;
          line-height: 54px;
        }
      }
    }
  }
  .tableWrap {
    // height: calc(100vh - 390px);
    overflow-y: auto;
  }
  .no-data-img {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 440px);
    img {
      width: 100px;
    }
  }
  .chooseWrap {
    padding: 10px 20px 10px 0;
    display: flex;
    align-items: center;
    // background-color: #141625;
    .itemSearch {
      margin-right: 20px;
      display: flex;
    }
  }
}
</style>
